import styled from 'styled-components';
import { Button } from 'antd';

export const ButtonWrapper = ({ children, ...rest }) => <PaddedButton {...rest}>{children}</PaddedButton>;

export const PaddedButton = styled(Button)`
  margin: 1px;
`;
